export default {
  buttons: {
    cancel: "Удалить",
    dismiss: "Закрыть",
    add_waypoint: "Добавить конечный пункт"
  },
  distance: {
    value: "{distance, number, distance} {unit}",
    unit: {
      miles: "мили"
    }
  },
  search: {
    title: "Поиск ",
    placeholder: "Введите местоположение",
    enter_location: "Введите местоположение",
    help: {
      inactive: "Поиск "
    }
  },
  filters: {
    title: "Фильтры",
    amenities: {
      title: "Сервис"
    },
    fuels: {
      title: "Виды топлива"
    }
  },
  directions: {
    title: "Запланировать маршрут",
    placeholder: {
      destination: "Введите местоположение",
      waypoint: "Введите местоположение"
    },
    route: {
      title: "Опции",
      avoid_tolls: "Избегать платных дорог",
      avoid_highways: "Избегать автомагистралей",
      title_corridor: "Расстояние до станции технического обслуживания"
    },
    travel_time: `\
{weeks, plural, =0 {} =1 {# wk} other {# wks}}
{days, plural, =0 {} =1 {# день} other {# дней}}
{hours, plural, =0 {} =1 {# hr} other {# hrs}}
{minutes, plural, =0 {} =1 {# min} other {# mins}}\
`,
    button: "Поиск "
  },
  locations: {
    title: "Местоположение",
    distance: "{distance, number, distance} {unit}",
    distance_from: "{distance, number, distance} {unit} из {place}"
  },
  info_window: {
    title: "Подробнее о станции",
    services: "Сервис",
    nearby: "Ближайший",
    mobile: {
      telephone: "Тел.:"
    },
    opening_hours: {
      title: "Часы работы",
      period: "{start, time, short} – {end, time, short}"
    },
    fuel_prices: {
      price: "{price, number, fuelPrice}",
      last_updated_on: "Последнее обновление",
      timestamp: "{timestamp, date, dateFormat}"
    }
  },
  itinerary: {
    title: "Запланировать маршрут"
  },
  fuels: {
    low_octane_gasoline: "АИ-92",
    midgrade_gasoline: "АИ-95",
    premium_diesel: "Shell V-Power Diesel",
    premium_gasoline: "Shell V-Power",
    shell_regular_diesel: "Дизель",
    super_premium_gasoline: "Shell V-Power Racing"
  },
  amenities: {
    air_and_water: "Воздух",
    atm: "Банкомат",
    bank_note_acceptor: "Банкомат",
    cafe: "Кафе",
    carwash: "Мойка",
    clubsmart_card: "Карты Shell Clubsmart",
    credit_card_american_express: "Кредитная карта - American Express",
    credit_card_diners_club: "Кредитная карта - Diners",
    credit_card_mastercard: "Кредитная карта - Mastercard",
    credit_card_visa: "Кредитная карта - Visa",
    credit_card: "Кредитная карта",
    euroshell_card: "euroShell",
    fleet_card_general: "Топливные карты",
    food_offerings: "Ассортимент кафе",
    full_service: "Полный сервис",
    guarded_car_park: "Охраняемая стоянка",
    hgv_lane: "Заправка грузовиков",
    high_speed_diesel_pump: "Высокоскоростная колонка Дизель",
    hot_food: "Горячая еда",
    parking_lanes: "Зона для парковки",
    pay_at_pump: "Оплата на ТРК",
    restaurant: "Ресторан",
    self_service: "Самообслуживание",
    shell_card: "euroShell",
    shop: "Магазин",
    shower: "Душ",
    snack_food: "Закуски",
    standard_toilet: "Туалет",
    supermarket_fuel_discount: "Топливо со скидкой",
    toilet: "Туалет",
    truck_parking: "Парковка для грузовиков",
    truckport: "Только грузовики",
    twenty_four_hour: "24 часа",
    vacuum: "Пылесос"
  },
  settings: {
    title: "Настройки",
    tooltip: "Настройки",
    distance_units: {
      title: "Расстояние",
      km: "км",
      miles: "мили"
    },
    language: {
      title: "Язык"
    }
  }
}
